/**
 * Future song titles received by Nigel's Future Beacon.
 *
 * Replace the placeholder with Pete's full title list. Keep one title per
 * array entry; the Song Signal system can later draw from this list with a
 * shuffle-bag so titles feel random without repeating too quickly.
 */
export const FUTURE_SONG_TITLES: readonly string[] = [
  "23rd Century Girl",
  "A Million Pictures",
  "Alive & Breathing",
  "Angel",
  "Aurora",
  "Beautiful Insane",
  "Best Friend's Girl",
  "Breaking Away",
  "Bussed Out",
  "Cabaret of Love",
  "Calling All The Dreamers",
  "Chemical Angel",
  "Cosmic Castaway",
  "Cry",
  "Dazed and Confused",
  "Demented",
  "Downer",
  "Dr Zack",
  "Easing My Soul",
  "Falling from the Stars",
  "Far Away",
  "Floating",
  "Footsoldierz",
  "Goin' Down",
  "Holiday in the Sun",
  "I Tried",
  "In Here We Fall",
  "Jesus Was a Junkie",
  "Lost In Space",
  "Lullaby",
  "Million of You",
  "Miracle",
  "Modern Girl",
  "Morning Afterglow",
  "Naked",
  "Nineteen",
  "Nothing to Do",
  "Out There",
  "Queen Of The Crimson Nile",
  "Radiate",
  "Renegades",
  "Rocketman",
  "Roll It Up",
  "Sacred",
  "Special Forces",
  "Statesman",
  "Strawberry Sunrise",
  "The Only Drug",
  "To the Other Side (feat. Jess Upton)",
  "Today's The Day",
  "White Noise",
  "Wired for Dreaming",
  "You Don't Get It",
] as const;

export type FutureSongTitle = (typeof FUTURE_SONG_TITLES)[number];
